// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentSummaryTable-m_cCczmxka_h6S8SHSuDNI {
  text-align: right;
}

.PaymentSummaryTable-m_gFANnbtTuqCHliBfRHbX {
  text-align: right;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./client/shared/PaymentSummaryTable/PaymentSummaryTable.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".amountCell {\n  text-align: right;\n}\n\n.totalCell {\n  text-align: right;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
export var amountCell = `PaymentSummaryTable-m_cCczmxka_h6S8SHSuDNI`;
export var totalCell = `PaymentSummaryTable-m_gFANnbtTuqCHliBfRHbX`;
export default ___CSS_LOADER_EXPORT___;
